import React from 'react'
import { Box } from '../UI';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button } from '@material-ui/core';
import pdf from '../../assets/dummy.pdf';
import { Link } from 'react-router-dom';
import PublishIcon from '@material-ui/icons/Publish';
import ListAltIcon from '@material-ui/icons/ListAlt';

const currencies = [
	{
		value: 'GBP',
		label: '£ (GBP)',
	},
	{
		value: 'USD',
		label: '$ (USD)',
	},
	{
		value: 'EUR',
		label: '€ (EUR)',
	},
];

export default function Meta({ currency, handleChange }) {
    return (
        <Box display="flex">
            <Box flexGrow={1} display="flex" alignItems='flex-end'>
                <TextField
                    id="outlined-select-currency"
                    select
                    value={currency}
                    onChange={handleChange}
                    variant="outlined"
                    size='small'
                    style={{ marginRight: '15px' }}
                >
                    {currencies.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
                <Box>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ marginRight: '15px' }}
                        component={Link}
                        to="/my-portfolio/new-asset"
                        startIcon={<PublishIcon />}
                    >
                        Upload Asset
                    </Button>
                    <a href={pdf} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                        <Button variant="contained" color="primary" startIcon={<ListAltIcon />}>
                            Create Summary
                        </Button>
                    </a>
                </Box>
            </Box>
        </Box>
    )
}
